export const showNewsguard = (score) => {
  if (score === null || score === undefined) {
    return false;
  }
  const numericScore = Number(score);
  return !isNaN(numericScore);
};
